import { StyleSheet } from 'react-native';
import Colors from './Colors';
import isMobile from '../components/IsMobile';

export default StyleSheet.create({
  boxShadow: {
    shadowOffset: {
      width: 0,
      height: 12,
    },
    shadowOpacity: 0.1,
    shadowRadius: 40,
    shadowColor: 'black',
    elevation: 5,
  },
  circleShadow: {
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.25,
    shadowRadius: 23,
    elevation: 5,
    shadowColor: '#0058AD',
  },
  dropShadow: {
    shadowOffset: {
      width: 6,
      height: 8,
    },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 5,
  },
  barShadow: {
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.25,
    shadowRadius: 16,
    borderRadius: 8,
    shadowColor: 'rgba(0, 31, 49, 1)',
    elevation: 5,
  },
  closeButton: {
    width: 36,
    height: 36,
    borderRadius: 18,
    position: 'absolute',
    right: isMobile ? 16 : 24,
    top: isMobile ? 16 : 24,
    backgroundColor: Colors.light.hereworksBlue50,
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButtonBlack: {
    position: 'absolute',
    right: isMobile ? 12 : 18,
    top: isMobile ? 12 : 24,
  },
  activityIndicator: {
    position: 'absolute',
    alignSelf: 'center',
    top: '49%',
    zIndex: 99,
  },
  row: {
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
  },
  modal: {
    margin: 0,
  },
  modalContent: {
    shadowColor: '#000',
    shadowOpacity: 0.5,
    shadowOffset: { width: 0, height: 8 },
    shadowRadius: 20,
    elevation: 8,
    backgroundColor: '#FFF',
    borderRadius: 10,
  },
  alertBoldText: { fontFamily: 'Roboto_700Bold' },
  dropdownText: {
    fontFamily: 'Poppins_400Regular',
    fontSize: 14,
    lineHeight: isMobile ? undefined : 21,
    color: Colors.light.hereworksBlack600,
  },
  commonCardStyle: {
    borderColor: Colors.light.hereworksWhite300,
    borderWidth: 1,
    borderRadius: 16,
    padding: isMobile ? 20 : 16,
    backgroundColor: '#fff',
    zIndex: -1,
    marginBottom: isMobile ? 16 : 24,
  },
  hovered: {
    opacity: 0.8,
  },
  pressed: {
    opacity: 0.4,
  },
  listItemHovered: {
    backgroundColor: Colors.light.hereworksWhite500,
  },
  listItemPressed: {
    backgroundColor: Colors.light.hereworksBlue100,
  },
  listItemSelected: {
    backgroundColor: Colors.light.hereworksDarkBlue,
  },
  dropdown: {
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksBlue100,
    borderRadius: 10,
    height: 40,
    width: '100%',
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  dropdownOption: {
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  title: {
    fontSize: isMobile ? 20 : 28,
    lineHeight: isMobile ? 24 : 34,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack600,
    textAlign: 'center',
    width: isMobile ? 'auto' : '100%',
  },
  selectedText: {
    color: '#fff',
  },
  unselectedText: {
    padding: 8,
    color: Colors.light.hereworksBlue500,
    fontFamily: 'Roboto_500Medium',
    fontSize: 12,
  },
  inverted: {
    transform: [{ rotate: '180deg' }],
  },
  upright: {
    transform: [{ rotate: '0deg' }],
  },
  disabled: {
    opacity: 0.2,
  },
  dropdownMenu: {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#FFF',
    maxHeight: 200,
    borderWidth: 1,
    borderRadius: 8,
    borderColor: Colors.light.hereworksBlue100,
  },
  textInputFocused: {
    borderColor: Colors.light.hereworksBlue400,
  },
  grabPoint: {
    position: 'absolute',
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: Colors.light.hereworksBlue500,
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    left: 0,
  },
  zoomButton: {
    margin: 8,
    backgroundColor: '#fff',
    width: 32,
    height: 32,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue500,
    justifyContent: 'center',
    alignItems: 'center',
  },
  toolButton: {
    marginVertical: 4,
    marginHorizontal: 0,
    width: 40,
    height: 40,
    borderRadius: 20,
  },
});
